define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function ViolatedFilenameFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    ViolatedFilenameFail.WEB_BACKEND_ERROR = 'violated_file_name';

    ViolatedFilenameFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: ViolatedFilenameFail,
        className: 'ViolatedFilenameFail',
        radarName: 'fail_{SOURCE}_violated-filename',
    });

    module.exports = ViolatedFilenameFail;
});
